
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.544 4.381L3.5 27.131l17.5.033.043-22.75-17.5-.033zm15.746 1.78l-.035 19.25-14-.026.035-19.25 14 .026z"}}),_c('path',{attrs:{"d":"M7.922 2.64l14.875.027-.037 20.125 1.75.003L24.55.92 7.925.89l-.003 1.75z"}}),_c('path',{attrs:{"d":"M16.564 15.78c.004-2.17-1.914-3.94-4.276-3.945-2.362-.004-4.287 1.759-4.291 3.93-.004 2.17 1.914 3.94 4.276 3.945 2.362.005 4.287-1.758 4.291-3.93zm-6.817-.012c.002-1.206 1.14-2.185 2.538-2.183 1.396.003 2.531.986 2.529 2.192-.002 1.207-1.14 2.186-2.538 2.183-1.396-.002-2.531-.986-2.529-2.192zM7.446 23.639l.003-1.75 9.625.018-.003 1.75-9.625-.018zM7.472 9.639l.003-1.75 9.625.018-.003 1.75-9.625-.018z"}})])
          )
        }
      }
    